import CustomInput from "../../../components/CustomInput";
import CustomSelect from "../../../components/CustomSelect";
import SubHeadings from "../../../components/SubHeadings";
import { Student } from "../../../types/studentType";
import { IS_LIVE } from "../../../util/config/env";

interface FamilyDetailsProps {
  data: Partial<Student>;
  onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => void;
}

export default function FamilyDetails({ data, onChange }: FamilyDetailsProps) {
  return (
    <div className="flex flex-col gap-9">
      <div className="flex justify-between items-center">
        <SubHeadings text="Family Details" />
      </div>

      <form className="grid lg:grid-cols-2 gap-7">
        
          <CustomInput
            name="fatherFullName"
            label="Father Name"
            placeholder="Enter Father Name"
            value={data.fatherFullName ?? ""}
            onChange={onChange}
            inputClassName="w-full"
          />
          <CustomInput
            name="fatherPhoneNumber"
            label="Father Phone Number"
            placeholder="Enter Father Phone Number"
            type="tel"
            value={data.fatherPhoneNumber ?? ""}
            onChange={onChange}
            inputClassName="w-full"
          />
          {!IS_LIVE && <CustomInput
            name="fatherEmail"
            label="Father Email"
            placeholder="Enter Father Email"
            type="email"
            value={data.fatherEmail ?? ""}
            onChange={onChange}
            inputClassName="w-full"
          />}
          <CustomInput
            name="fatherOccupation"
            label="Father Occupation"
            placeholder="Enter Father Occupation"
            value={data.fatherOccupation ?? ""}
            onChange={onChange}
            inputClassName="w-full"
          />

          <CustomInput
            name="motherFullName"
            label="Mother Name"
            placeholder="Enter Mother Name"
            value={data.motherFullName ?? ""}
            onChange={onChange}
            inputClassName="w-full"
          />
          <CustomInput
            name="motherPhoneNumber"
            label="Mother Phone Number"
            placeholder="Enter Mother Phone Number"
            type="tel"
            value={data.motherPhoneNumber ?? ""}
            onChange={onChange}
            inputClassName="w-full"
          />
          {!IS_LIVE && <CustomInput
            name="motherEmail"
            label="Mother Email"
            placeholder="Enter Mother Email"
            type="email"
            value={data.motherEmail ?? ""}
            onChange={onChange}
            inputClassName="w-full"
          />}
          <CustomInput
            name="motherOccupation"
            label="Mother Occupation"
            placeholder="Enter Mother Occupation"
            value={data.motherOccupation ?? ""}
            onChange={onChange}
            inputClassName="w-full"
          />

          {!IS_LIVE && <CustomInput
            name="languageSpokenAtHome"
            label="Language Spoken at Home"
            placeholder="Enter language spoken at home"
            value={data.languageSpokenAtHome ?? ""}
            onChange={onChange}
            inputClassName="w-full"
          />}

          <CustomInput
            name="residentialAddress"
            label="Residential Address"
            placeholder="Enter full permanent address"
            value={data.residentialAddress ?? ""}
            onChange={onChange}
            inputClassName="w-full"
          />
        

          <CustomInput
            name="emergencyContactName"
            label="Emergency Contact Name"
            placeholder="Enter Emergency Contact Name"
            value={data.emergencyContactName ?? ""}
            onChange={onChange}
            inputClassName="w-full"
          />
          <CustomInput
            name="emergencyContactNumber"
            label="Emergency Contact Number"
            placeholder="Enter Emergency Contact Number"
            type="tel"
            value={data.emergencyContactNumber ?? ""}
            onChange={onChange}
            inputClassName="w-full"
          />
          <CustomSelect
            name="familyType"
            label="Family Type"
            placeholder="Select Family Type"
            options={["Nuclear", "Joint", "Single Parent"]}
            value={data.familyType ?? ""}
            onChange={onChange}
            selectClassName="w-full"
          />
      </form>
    </div>
  );
}
